// ============================================
// Area Chart Layout Constants
// ============================================

/** X-axis height for time labels */
export const X_AXIS_HEIGHT = 20

/** Y-axis width for value labels */
export const Y_AXIS_WIDTH = 40

/** Y-axis padding from edges */
export const Y_AXIS_PADDING = 2

// ============================================
// Bar Chart Layout Constants
// ============================================

/** Maximum width for bar labels */
export const LABEL_MAX_WIDTH = 100

/** Text vertical adjustment */
export const TEXT_ADJUST_Y = 12

/** Height of each bar row */
export const ROW_HEIGHT = 13

/** Vertical padding between rows */
export const PADDING_Y = 7

/** Horizontal padding */
export const PADDING_X = 8

/** Bar opacity */
export const RECT_OPACITY = 0.8

/** Capacity bar opacity (background) */
export const CAPACITY_OPACITY = 0.15

/** Capacity bar color (neutral gray) */
export const CAPACITY_COLOR = 'rgba(0, 0, 0, 0.1)'

/** Number of scale ticks for bar chart axis */
export const SCALE_TICKS = 4

/** Axis legend padding */
export const AXIS_LEGEND_PADDING = 0

/** Icon plus text padding */
export const ICON_PLUS_PADDING = 18

/** Legend icon size */
export const LEGEND_ICON_SIZE = 16

/** Legend icon corner radius */
export const LEGEND_ICON_RADIUS = 2

// ============================================
// Colors
// ============================================

/** Colors for market programs */
export const MARKET_COLORS: Record<string, string> = {
  'mFRR UP': '#059669', // Emerald
  'mFRR DOWN': '#dc2626', // Red
  'FCR-D UP': '#0891b2', // Cyan
  'FCR-D DOWN': '#9333ea', // Purple
  'FCR-N': '#ca8a04', // Amber
}

/** Layer colors for confidence intervals */
export const LAYER_COLORS = {
  p80: 'rgba(59, 130, 246, 0.15)', // Blue, low opacity
  p50: 'rgba(59, 130, 246, 0.30)', // Blue, medium opacity
  mean: '#2563eb', // Solid blue
}

// ============================================
// Axis Styling
// ============================================

/** Axis line color - dark grey */
export const AXIS_LINE_COLOR = '#b9b9b9' // Gray-500

/** Major tick color - dark grey */
export const MAJOR_TICK_COLOR = '#b9b9b9' // Gray-500

/** Minor tick color - light grey */
export const MINOR_TICK_COLOR = '#ededed' // Gray-300

/** Axis text color */
export const AXIS_TEXT_COLOR = '#a9a9a9' // Gray-500

/** Tick font size */
export const TICK_FONT_SIZE = '0.6rem'

/** Small tick font size (when many ticks) */
export const TICK_FONT_SIZE_SMALL = '0.5rem'

/** Major tick height */
export const MAJOR_TICK_HEIGHT = 6

/** Minor tick height (smaller) */
export const MINOR_TICK_HEIGHT = 4

/** Midnight marker color */
export const MIDNIGHT_MARKER_COLOR = '#9ca3af' // Gray-400

/** Midnight marker opacity */
export const MIDNIGHT_MARKER_OPACITY = 0.6
